module.exports = "<ng-transclude class=\"<%= separator %>\"></ng-transclude>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/contacts/common/components/SubtitleSeparator/SubtitleSeparator.html
// module id = 696
// module chunks = 0